var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Shipment Required Fields")]),
      _c(
        "md-table",
        { staticClass: "custom-paginated-table" },
        [
          _c(
            "md-table-row",
            [
              _c("md-table-head", [_vm._v("Field")]),
              _c("md-table-head", [_vm._v("Required")]),
            ],
            1
          ),
          _vm._l(_vm.shipmentFields, function (field) {
            return field.visible
              ? _c(
                  "md-table-row",
                  { key: field.key },
                  [
                    _c("md-table-cell", [_vm._v(_vm._s(field.label))]),
                    _c("md-table-cell", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.checked,
                            expression: "field.checked",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(field.checked)
                            ? _vm._i(field.checked, null) > -1
                            : field.checked,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = field.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(field, "checked", $$c)
                              }
                            },
                            _vm.markDirty,
                          ],
                        },
                      }),
                    ]),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _c("div", { staticClass: "table-gap" }),
      _c("h4", [_vm._v("Shipment Pickup Required Fields")]),
      _c(
        "md-table",
        { staticClass: "custom-paginated-table" },
        [
          _c(
            "md-table-row",
            [
              _c("md-table-head", [_vm._v("Field")]),
              _c("md-table-head", [_vm._v("Required")]),
            ],
            1
          ),
          _vm._l(_vm.shipmentPickupFields, function (field) {
            return field.visible
              ? _c(
                  "md-table-row",
                  { key: field.key },
                  [
                    _c("md-table-cell", [_vm._v(_vm._s(field.label))]),
                    _c("md-table-cell", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.checked,
                            expression: "field.checked",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(field.checked)
                            ? _vm._i(field.checked, null) > -1
                            : field.checked,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = field.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(field, "checked", $$c)
                              }
                            },
                            _vm.markDirty,
                          ],
                        },
                      }),
                    ]),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _c("div", { staticClass: "table-gap" }),
      _c("h4", [_vm._v("Shipment Dropoff Required Fields")]),
      _c(
        "md-table",
        { staticClass: "custom-paginated-table" },
        [
          _c(
            "md-table-row",
            [
              _c("md-table-head", [_vm._v("Field")]),
              _c("md-table-head", [_vm._v("Required")]),
            ],
            1
          ),
          _vm._l(_vm.shipmentDropoffFields, function (field) {
            return field.visible
              ? _c(
                  "md-table-row",
                  { key: field.key },
                  [
                    _c("md-table-cell", [_vm._v(_vm._s(field.label))]),
                    _c("md-table-cell", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: field.checked,
                            expression: "field.checked",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(field.checked)
                            ? _vm._i(field.checked, null) > -1
                            : field.checked,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = field.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      field,
                                      "checked",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(field, "checked", $$c)
                              }
                            },
                            _vm.markDirty,
                          ],
                        },
                      }),
                    ]),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      ),
      _c(
        "md-button",
        {
          staticClass: "md-primary",
          attrs: { disabled: !_vm.isDirty },
          on: { click: _vm.saveChanges },
        },
        [_vm._v("Save Changes")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }